@if (totalEmojiCount() > 0) {
  <button
    type="button"
    class="emoji-pill d-inline-flex align-items-center gap-2 border-0"
    [class.emoji-pill-own]="ownMessage()"
    [class.emoji-pill-other]="!ownMessage()"
    [style.height]="height()"
    [style.font-size]="textSize()"
    (click)="openDialog()"
  >
    <span class="d-inline-flex align-items-center gap-1 lh-1">
      @for (emoji of previewEmojis(); track emoji) {
        <span class="emoji-pill-emoji">{{ emoji }}</span>
      }
    </span>
    <span class="emoji-pill-count">{{ totalEmojiCount() }}</span>
  </button>
}
